import { SolicitacaoChatAreaResponsavelEnum } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-area-responsavel.enum'
import { IRemuneracaoChatMessageType, IRemuneracaoChatMessage } from '@/types/interfaces/backoffice-remuneracao/remuneracao-chat-message.interface'
import EventBus from '@/plugins/EventBus'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { maskCPFCNPJ, maskDate, maskDateMonth, maskDateTime } from '@/utils/common'
import { getModule } from 'vuex-module-decorators'
import ChatFinanceiroStore from './store/chat-financeiro-store'
import ChatFinanceiroModule from './chat-financeiro.module'

@Component({
  components: ChatFinanceiroModule.components,
})
export default class ComponentChatFinanceiro extends Vue {
  channel: SolicitacaoChatAreaResponsavelEnum | string = '';
  canShowRightPanel: boolean = false
  loadEncerrarAtendimento: boolean = false
  modalEncerrarAtendimento: boolean = false
  solicitacaoChatAreaResponsavelEnum = SolicitacaoChatAreaResponsavelEnum

  get loadingEncerrarAtendimento() { return this.loadEncerrarAtendimento }
  set loadingEncerrarAtendimento(value: boolean) { this.loadEncerrarAtendimento = value }

  mounted() {
    // Check can show right panel when starts based in screen width
    if (window.screen.availWidth > 600 && !this.chatStore.ehUsuarioAtendimento) {
      this.canShowRightPanel = true
    }
  }

  send(value: string) {
    const message = {
      ...this.chatStore.connectionData,
      mensagem: value,
    } as IRemuneracaoChatMessage

    this.chatStore.sendMessage(message)
  }

  chooseChannel(channel: string) {
    this.channel = channel
    // this.chatStore.setChatArea(channel as SolicitacaoChatAreaResponsavelEnum)
    this.ga('recebimento', `escolher-canal-${channel}`)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async close() {
    await this.chatStore.closeChatModal()
    this.channel = ''
  }

  getMessageSide(data: any) {
    const loggedUserId = this.$user.profile.sub
    if (data.userId ? data.userId : data.createdBy === loggedUserId) {
      return 'right'
    }

    return 'left'
  }

  getCanShowFooter(data: IRemuneracaoChatMessage) {
    const loggedUserId = this.$user.profile.sub

    if (
      data.userId === loggedUserId
    ) {
      return true
    }

    return false
  }

  async encerrarAtendimento() {
    this.loadingEncerrarAtendimento = true
    const response = await this.chatStore.encerrarAtendimento()
    if (response.success) {
      this.chatStore.setOpen(false)
    }
    this.loadingEncerrarAtendimento = false
  }

  openEncerrarAtendimento() {
    this.modalEncerrarAtendimento = true
  }

  closeModalEncerrarAtendimento() {
    this.modalEncerrarAtendimento = false
  }

  getSenderName(data: IRemuneracaoChatMessage) {
    const loggedUserId = this.$user.profile.sub

    if (
      data.userId ? data.userId : data.createdBy !== loggedUserId
    ) {
      return data.nome || data.usuarioNome
    }

    return ''
  }

  toggleRightPanel() {
    this.canShowRightPanel = !this.canShowRightPanel
  }

  formatDateForDay(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      let completedDate: string
      if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
        completedDate = 'Hoje'
      } else {
        completedDate = date.toLocaleDateString()
      }

      return `${completedDate} às ${hours}:${minutes}`
    }

    return ''
  }

  get canShowChooseChannel() {
    return !this.channel && this.needChooseChannel
  }

  get needChooseChannel() {
    return this.chatStore.finished || this.chatStore.finished == null
  }

  maskCPFCNPJUtil(value: any) {
    return maskCPFCNPJ(String(value))
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatDateMonth(date: string) {
    return maskDateMonth(date)
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  hasSituacao(situacao: string | undefined) {
    if (!situacao) return false
    return ['divergente', 'pendente', 'paga', 'pago'].includes(situacao.toLowerCase())
  }

  get chatStore() {
    return getModule(ChatFinanceiroStore, this.$store)
  }
}
